/**
 * Verifica si la variable de entrada tiene valor.
 * La función revisa si el valor no es `null` ni `undefined`, y que no sea una cadena vacía.
 *
 * @param {*} input - La variable de entrada que se va a verificar.
 * @returns {boolean} - Devuelve `true` si la variable tiene un valor, no es `null`, `undefined`, ni una cadena vacía. De lo contrario, devuelve `false`.
 *
 * @example
 * // Ejemplos de uso:
 * console.debug(hasValue(null));        // false
 * console.debug(hasValue(undefined));   // false
 * console.debug(hasValue(''));          // false
 * console.debug(hasValue('   '));       // false
 * console.debug(hasValue('Hello'));     // true
 * console.debug(hasValue(0));           // true
 * console.debug(hasValue(false));       // true
 * console.debug(hasValue([]));          // true
 * console.debug(hasValue({}));          // true
 */
export function hasValue<T>(input: T): boolean {
    if (input === null || input === undefined) {
        return false;
    }
    if (typeof input === 'string' && input.trim() === '') {
        return false;
    }
    return true;
}
